/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Interface representing Vapi voice configuration
 */
export type VapiVoiceConfig = {
    provider?: VapiVoiceConfig.provider;
    voiceId?: string;
    model?: string;
    speed?: number;
    stability?: number;
    style?: number;
    optimizeStreamingLatency?: number;
};
export namespace VapiVoiceConfig {
    export enum provider {
        _11LABS = '11labs',
    }
}

